export default "__VITE_ASSET__fud_MDCO__"